export const numbers = {
  path: 'numbers',
  name: 'pbx.number.index',
  component: () => import(/* webpackChunkName: 'pbx-numbers' */ '@pbx/pages/numbers/list'),
  meta: {
    title: {
      code: 'pbx.breadcrumb.number.index'
    }
  }
};
